module.exports = __webpack_public_path__ + "static/media/flowbuilders.bee8364a.png";